import { BN } from "@project-serum/anchor";
import { PublicKey } from "@saberhq/solana-contrib";
export const SYRUP_ADDRESSES = {
    Syrup: new PublicKey("5D9yi4BKrxF8h65NkVE1raCCWFKUs5ngub2ECxhvfaZe"),
};
export const DOLLARS = new BN(1000000);
export const SECONDS_PER_DAY = new BN(86400);
export const SECONDS_PER_YEAR = SECONDS_PER_DAY.muln(365);
export const SCALED_ONE = new BN(10).pow(new BN(18));
//# sourceMappingURL=constants.js.map